/**
 * FAQ accordion interactions.
 *
 * @return {void}
 */
export function initFaqAccordion() {
	const blocks = document.querySelectorAll('[data-faq-accordion]');

	blocks.forEach((block) => {
		const triggers = block.querySelectorAll('[data-faq-trigger]');

		triggers.forEach((trigger) => {
			trigger.addEventListener('click', () => {
				const item = trigger.closest('[data-faq-item]');

				if (!(item instanceof HTMLElement)) {
					return;
				}

				const is_open = item.classList.contains('is-open');

				block.querySelectorAll('[data-faq-item].is-open').forEach((open_item) => {
					if (open_item !== item) {
						setFaqItemState(open_item, false);
					}
				});

				setFaqItemState(item, !is_open);
			});
		});
	});
}

/**
 * @param {HTMLElement} item
 * @param {boolean} is_open
 * @return {void}
 */
function setFaqItemState(item, is_open) {
	const trigger = item.querySelector('[data-faq-trigger]');
	const panel = item.querySelector('[data-faq-panel]');

	item.classList.toggle('is-open', is_open);

	if (trigger instanceof HTMLButtonElement) {
		trigger.setAttribute('aria-expanded', is_open ? 'true' : 'false');
	}

	if (panel instanceof HTMLElement) {
		panel.setAttribute('aria-hidden', is_open ? 'false' : 'true');
	}
}
